import React from 'react';

/**
 * BrandLogo — EcoBike Camping Supplies Co. heritage Ben Lomond medallion.
 *
 * Renders the founder's Dola AI badge design (deep forest-green enamel, brass
 * rope frame, embossed Ben Lomond scene, "BAIN" nameplate, ® mark) from a
 * static PNG with a transparent background so it sits cleanly on light or
 * dark surfaces.
 *
 * Cache-bust version tag — bump this when the medallion file is updated so
 * customers' browsers pick up the new asset immediately instead of showing
 * a stale cached copy.
 */
const MEDALLION_VERSION = '5-brightened-original';

export default function BrandLogo({ size = 96, className = '', alt = 'EcoBike Camping Supplies Co. medallion' }) {
  return (
    <img
      src={`/brand/medallion.png?v=${MEDALLION_VERSION}`}
      width={size}
      height={size}
      alt={alt}
      className={className}
      style={{
        display: 'block',
        width: size,
        height: size,
        objectFit: 'contain',
        // Tiny drop-shadow to give the medallion a sense of lifting off any background
        filter: 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35))',
      }}
      draggable={false}
    />
  );
}
